import api from "./api";
import { getStoredClientId, getStoredUser } from "../utils/tokenUtils";

const datasetService = {
  /**
   * Get all datasets for a project
   */
  getDatasets: async (projectId, filters = {}) => {
    const user = getStoredUser();
    const storedClientId = getStoredClientId();
    const payload = {
      project_id: projectId,
      client_id: storedClientId || user?.client_id,
      search: filters.search || undefined,
    };
    const response = await api.post("/api/datasets/list", payload);
    return response.data;
  },

  /**
   * Get dataset by ID
   */
  getDatasetById: async (datasetId) => {
    const user = getStoredUser();
    const storedClientId = getStoredClientId();
    const payload = {
      dataset_id: datasetId,
      client_id: storedClientId || user?.client_id,
    };
    const response = await api.post("/api/datasets/get", payload);
    return response.data;
  },

  /**
   * Create a new dataset
   */
  createDataset: async (datasetData) => {
    const user = getStoredUser();
    const storedClientId = getStoredClientId();
    const payload = {
      ...datasetData,
      client_id: storedClientId || user?.client_id,
    };
    const response = await api.post("/api/datasets/create", payload);
    return response.data;
  },

  /**
   * Update a dataset
   */
  updateDataset: async (datasetId, updates) => {
    const user = getStoredUser();
    const storedClientId = getStoredClientId();
    const payload = {
      dataset_id: datasetId,
      ...updates,
      client_id: storedClientId || user?.client_id,
    };
    const response = await api.post("/api/datasets/update", payload);
    return response.data;
  },

  /**
   * Delete a dataset
   */
  deleteDataset: async (datasetId) => {
    const user = getStoredUser();
    const storedClientId = getStoredClientId();
    const payload = {
      dataset_id: datasetId,
      client_id: storedClientId || user?.client_id,
    };
    const response = await api.post("/api/datasets/delete", payload);
    return response.data;
  },

  /**
   * Add value to dataset
   */
  addValueToDataset: async (datasetId, rowData, position) => {
    const user = getStoredUser();
    const storedClientId = getStoredClientId();
    const payload = {
      dataset_id: datasetId,
      row_data: rowData,
      position,
      client_id: storedClientId || user?.client_id,
    };
    const response = await api.post("/api/datasets/add-value", payload);
    return response.data;
  },

  /**
   * Update dataset value
   */
  updateDatasetValue: async (datasetId, valueId, rowData) => {
    const user = getStoredUser();
    const storedClientId = getStoredClientId();
    const payload = {
      dataset_id: datasetId,
      value_id: valueId,
      row_data: rowData,
      client_id: storedClientId || user?.client_id,
    };
    const response = await api.post("/api/datasets/update-value", payload);
    return response.data;
  },

  /**
   * Delete dataset value
   */
  deleteDatasetValue: async (datasetId, valueId) => {
    const user = getStoredUser();
    const storedClientId = getStoredClientId();
    const payload = {
      dataset_id: datasetId,
      value_id: valueId,
      client_id: storedClientId || user?.client_id,
    };
    const response = await api.post("/api/datasets/delete-value", payload);
    return response.data;
  },

  /**
   * Link dataset to test case
   */
  linkToTestCase: async (datasetId, testCaseId) => {
    const user = getStoredUser();
    const storedClientId = getStoredClientId();
    const payload = {
      dataset_id: datasetId,
      test_case_id: testCaseId,
      client_id: storedClientId || user?.client_id,
    };
    const response = await api.post("/api/datasets/link-to-test-case", payload);
    return response.data;
  },

  /**
   * Unlink dataset from test case
   */
  unlinkFromTestCase: async (datasetId, testCaseId) => {
    const user = getStoredUser();
    const storedClientId = getStoredClientId();
    const payload = {
      dataset_id: datasetId,
      test_case_id: testCaseId,
      client_id: storedClientId || user?.client_id,
    };
    const response = await api.post(
      "/api/datasets/unlink-from-test-case",
      payload,
    );
    return response.data;
  },

  /**
   * Get linked test cases for a dataset
   */
  getLinkedTestCases: async (datasetId) => {
    const user = getStoredUser();
    const storedClientId = getStoredClientId();
    const payload = {
      dataset_id: datasetId,
      client_id: storedClientId || user?.client_id,
    };
    const response = await api.post(
      "/api/datasets/get-linked-test-cases",
      payload,
    );
    return response.data;
  },
};

// Export as both default and named for compatibility
export default datasetService;
export { datasetService };
